export const getGridStyle = ({ responsive = false })=>{
    return {
        width: '100%',
        ...responsive ? {} : {
            display: 'grid',
            gridAutoRows: 'minmax(min-content, max-content) 1fr'
        }
    };
};

//# sourceMappingURL=grid-options.js.map